import {Chip, Stack, Typography} from "@mui/material";
import React from "react";
import {Accessibility} from "../../component/accessibility";
import {B2Site} from "../../data/client.gen";
import {useLocalization} from "../../i18n";

export function OpeningHours({site}: { site: B2Site }) {
	const {t} = useLocalization();

	return (
		<Stack direction="column" gap={1}>
			<Stack direction="row" justifyContent="space-between" alignItems="center" gap={1}>
				<Typography variant="subtitle1">{t("storefront.openingHours.title")}</Typography>
				<Chip
					size="small"
					color={site.currentlyOpen ? "success" : "default"}
					label={site.currentlyOpen
						? t("storefront.openingHours.openNow")
						: t("storefront.openingHours.closed")}
				/>
			</Stack>
			<Typography variant="body2" color="text.secondary" component="div">
				<Accessibility site={site} />
			</Typography>
		</Stack>
	);
}
